import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import { getPictureUrlFromBase64 } from './../../../../../../utils/index';

const Photos = ({
  pictures,
  setPhotoIds,
  currentPhotoIndex,
  photoHoverId,
  setPhotoHover,
  removePhotoHover,
  setCurrentPhotoIndex
}) => {

  const containerStyle = {
    display: 'flex',
    minHeight: '300px',
    flexDirection: 'column'
  }
  const leftStyle = {
    display: 'flex',
    // padding: '10px',
    // paddingLeft: '0px',
    padding: '30px',
    paddingBottom: '0px'
  }
  const rightStyle = {
    display: 'flex',
    padding: '20px',
    justifyContent: 'center'
    // marginLeft: '-6px',
    // paddingLeft: '0px'
  }
  const itemStyle = {
    display: 'flex',
    width: '160px',
    height: '120px',
    padding: '2px',
    marginLeft: '8px',
    marginTop: '8px',
    cursor: 'pointer'
  }

  const mainPictId = setPhotoIds[currentPhotoIndex];
  const mainPict = pictures[mainPictId] || '';
  const mainUrl = getPictureUrlFromBase64(mainPict);
  const bgMainStyle = {
    padding: '2px',
    height: '25vh',
    minHeight: '350px',
    width: '100%',
    backgroundClip: 'content-box',
    backgroundImage: 'url("' + mainUrl + '")',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  };

  return (
    <div style={containerStyle} className='setPhotos'>
      <div style={leftStyle}>
        <Paper style={bgMainStyle} zDepth={0}>
        </Paper>
      </div>
      <div style={rightStyle}>
        <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center'}}>
          {
            setPhotoIds.map((id, i) => {
              const pict = pictures[id] || '';
              const u = 'data:image/;base64,' + pict.replace(/\r\n/g, '');
              const bgStyle = {
                backgroundClip: 'content-box',
                backgroundImage: 'url("' + u + '")',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
              };
              return (
                <Paper
                  key={id}
                  zDepth={id === photoHoverId ? 4 : 2}
                  style={{...itemStyle, ...bgStyle}}
                  onMouseEnter={
                    () => {
                      setPhotoHover(id);
                    }
                  }
                  onMouseLeave={removePhotoHover}
                  onClick={
                    () => {
                      setCurrentPhotoIndex(i);
                    }
                  }
                />
              )
            })
          }

        </div>
      </div>
    </div>
  );
}

Photos.propTypes = {
  pictures: PropTypes.object.isRequired,
  currentPhotoIndex: PropTypes.number.isRequired
}

export default connect(
  state => ({ pictures: state.pictures, setPhotoIds: state.sets[state.ui.set].photo || [] })
)(Photos);



// WEBPACK FOOTER //
// ./src/components/layout/content/catalog/set/card/photos.js